import PageNotFound from './PageNotFound.vue';

export { PageNotFound };
export default PageNotFound;
